// extracted by mini-css-extract-plugin
module.exports = {"relatedContent":"related-content-module--relatedContent--3jrZk"};